//1 )  representa lo que se va almacenar globalmente 
export const initialState = {
    LoadHome: false,
    texto: ''
}

//2) logica de como se va almacenar y manejar lo que se va guardar 
const cargandoReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOAD_HOME":
            return {
                ...state,
                LoadHome: true,
                texto: action.texto
            }
        case "CLOSE_LOAD_HOME":
            return {
                ...state,
                LoadHome: false
            }
        default: return state;
    }
};

//3) Se exporta 
export default cargandoReducer;